// ============================================================
//  Camp Preview Calendar (logged-out view)
//  4Cats Arts Studio
//
//  Shows a read-only-but-clickable calendar of camp dates to visitors
//  who haven't logged in yet - same visual styling (available/limited
//  spots/AM-PM split) as the real booking widget's calendar, reusing
//  the same CSS classes already present on each camp page.
//
//  Clicking an available date doesn't book anything here - it stores
//  the chosen studio+date (and AM/PM slot, if applicable) to
//  localStorage, then sends the visitor to log in. The real widget
//  (camp-block.js) picks that selection back up automatically once
//  they're logged back in and land on this same page.
// ============================================================

(function () {
  var SUPABASE_URL = 'https://snxibhbhhchjthfmjtaj.supabase.co';
  var ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNueGliaGJoaGNoanRoZm1qdGFqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzcwNTk2ODAsImV4cCI6MjA5MjYzNTY4MH0.K-89Mx4SxU6N1hMmtK6Q79rWAtk6VTN9b5wemQxcZVA';
  var PREF_KEY = '4cats_preferred_studio';
  var PRESELECT_KEY = '4cats_camp_preselect';
  var RETURN_KEY = '4cats_return_after_login';

  function getConfig() {
    var el = document.getElementById('cp-widget');
    return {
      collectionId: (el && el.getAttribute('data-collection-id')) || ''
    };
  }
  var CONFIG = getConfig();

  var STUDIOS = [
    { id: 'BC-RICH-GC', match: 'RICHMOND - GARDEN CITY', name: 'Richmond \u2013 Garden City' },
    { id: 'BC-RICH-STV', match: 'RICHMOND - STEVESTON', name: 'Richmond \u2013 Steveston' },
    { id: 'BC-SUR-SSR', match: 'SURREY - SOUTH', name: 'Surrey \u2013 South' },
    { id: 'BC-YVR-KIT', match: 'VANCOUVER - KITSILANO', name: 'Vancouver \u2013 Kitsilano' },
    { id: 'BC-YVR-MS', match: 'VANCOUVER - MAIN STREET', name: 'Vancouver \u2013 Main Street' },
    { id: 'BC-YVR-UBC', match: 'VANCOUVER - UBC', name: 'Vancouver \u2013 UBC' },
    { id: 'BC-YYJ-CSV', match: 'VICTORIA - COOK STREET VILLAGE', name: 'Victoria \u2013 Cook Street Village' },
    { id: 'BC-YYJ-ESQ', match: 'VICTORIA - ESQUIMALT', name: 'Victoria \u2013 Esquimalt' },
    { id: 'BC-YYJ-OB', match: 'VICTORIA - OAK BAY', name: 'Victoria \u2013 Oak Bay' },
    { id: 'BC-YYJ-VIC', match: 'VICTORIA - UPTOWN', name: 'Victoria \u2013 Uptown' },
    { id: 'AB-YYC-ING', match: 'CALGARY - INGLEWOOD', name: 'Calgary \u2013 Inglewood' },
    { id: 'AB-STA-STA', match: 'ST ALBERT', name: 'St. Albert' },
    { id: 'ON-BRL-BRL', match: 'BURLINGTON - SOUTH', name: 'Burlington \u2013 South' },
    { id: 'ON-CMB-GLT', match: 'CAMBRIDGE - GALT', name: 'Cambridge \u2013 Galt' },
    { id: 'ON-ERN-ERN', match: 'ERIN', name: 'Erin' },
    { id: 'ON-HAM-OS', match: 'HAMILTON - OTTAWA STREET', name: 'Hamilton \u2013 Ottawa Street' },
    { id: 'ON-HAM-WD', match: 'HAMILTON - WATERDOWN', name: 'Hamilton \u2013 Waterdown' },
    { id: 'ON-HAM-WH', match: 'HAMILTON - WEST HARBOUR', name: 'Hamilton \u2013 West Harbour' },
    { id: 'ON-KGN-AP', match: 'KINGSTON - ARLINGTON PARK', name: 'Kingston \u2013 Arlington Park' },
    { id: 'ON-LDN-BYR', match: 'LONDON - BYRON', name: 'London \u2013 Byron' },
    { id: 'ON-LDN-WVG', match: 'LONDON - WORTLEY VILLAGE', name: 'London \u2013 Wortley Village' },
    { id: 'ON-MIS-PC', match: 'MISSISSAUGA - PORT CREDIT', name: 'Mississauga \u2013 Port Credit' },
    { id: 'ON-OAK-OAK', match: 'OAKVILLE - NORTH', name: 'Oakville \u2013 North' },
    { id: 'ON-OAK-WST', match: 'OAKVILLE - WEST', name: 'Oakville \u2013 West' },
    { id: 'ON-YOW-GLB', match: 'OTTAWA - THE GLEBE', name: 'Ottawa \u2013 The Glebe' },
    { id: 'ON-STC-STC', match: 'ST CATHARINES', name: 'St. Catharines' },
    { id: 'ON-YYZ-AVE', match: 'TORONTO - AVENUE ROAD', name: 'Toronto \u2013 Avenue Road' },
    { id: 'ON-YYZ-BP', match: 'TORONTO - BABY POINT', name: 'Toronto \u2013 Baby Point' },
    { id: 'ON-YYZ-LEA', match: 'TORONTO - LEASIDE', name: 'Toronto \u2013 Leaside' },
    { id: 'ON-YYZ-BEA', match: 'TORONTO - THE BEACHES', name: 'Toronto \u2013 The Beaches' },
    { id: 'ON-WTR-WTR', match: 'WATERLOO - UPTOWN', name: 'Waterloo \u2013 Uptown' }
  ];

  function studioIdFromVariantTitle(variantTitle) {
    var cleaned = String(variantTitle || '')
      .toUpperCase()
      .replace(/^(AB|BC|ON)\s*\/\s*/, '')
      .replace(/\s*\/.*$/, '')
      .trim();
    for (var i = 0; i < STUDIOS.length; i++) {
      if (STUDIOS[i].match === cleaned) return STUDIOS[i].id;
    }
    return null;
  }

  function studioName(id) {
    for (var i = 0; i < STUDIOS.length; i++) {
      if (STUDIOS[i].id === id) return STUDIOS[i].name;
    }
    return id;
  }

  function getPreselectStudio() {
    var m = window.location.search.match(/[?&]studio=([^&]+)/);
    if (m) return decodeURIComponent(m[1]);
    try {
      var ls = localStorage.getItem(PREF_KEY);
      if (ls) return ls;
    } catch (e) {}
    return null;
  }

  function extractEventDateISO(title) {
    var m = title.match(/\b(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\w*\s+(\d{1,2})/i);
    if (!m) return null;
    var now = new Date();
    var year = now.getFullYear();
    var d = new Date(m[1] + ' ' + m[2] + ' ' + year);
    if (isNaN(d.getTime())) return null;
    var cutoff = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
    if (d < cutoff) {
      d = new Date(m[1] + ' ' + m[2] + ' ' + (year + 1));
    }
    return d.toISOString().split('T')[0];
  }

  function extractTimeLabel(title) {
    var m = title.match(/^(\*?\d{1,2}(?::\d{2})?(?:am|pm))/i);
    return m ? m[1].replace('*', '') : null;
  }

  function offeringTimeSlot(o) {
    if (!o.timeLabel) return null;
    return /am$/i.test(o.timeLabel) ? 'AM' : 'PM';
  }

  function q(id) { return document.getElementById(id); }

  function fetchCollectionProducts() {
    var url = SUPABASE_URL + '/functions/v1/public-collection-products?collection_id=' + encodeURIComponent(CONFIG.collectionId);
    return fetch(url, { headers: { Authorization: 'Bearer ' + ANON_KEY, apikey: ANON_KEY } })
      .then(function (r) { return r.json(); })
      .then(function (data) { return (data && data.products) || []; });
  }

  function buildOfferings(products) {
    var offerings = [];
    products.forEach(function (p) {
      var title = String(p.title || '');
      var iso = extractEventDateISO(title);
      var timeLabel = extractTimeLabel(title);
      if (!iso) return;
      (p.variants || []).forEach(function (v) {
        var sid = studioIdFromVariantTitle(v.title);
        if (!sid) return;
        offerings.push({
          studioId: sid,
          date: iso,
          timeLabel: timeLabel,
          spacesLeft: (typeof v.spacesLeft === 'number') ? v.spacesLeft : null,
          available: v.available !== false
        });
      });
    });
    return offerings;
  }

  var allOfferings = [];
  var calYear = null;
  var calMonth = null;
  var currentStudioId = null;

  function populateStudioSelect(availableStudioIds) {
    var sel = q('cp-studio-select');
    sel.innerHTML = '<option value="">Choose a studio\u2026</option>';
    var list = STUDIOS.filter(function (s) { return availableStudioIds.indexOf(s.id) !== -1; });
    list.sort(function (a, b) { return a.name.localeCompare(b.name); });
    list.forEach(function (s) {
      var opt = document.createElement('option');
      opt.value = s.id;
      opt.textContent = s.name;
      sel.appendChild(opt);
    });
  }

  function goToLogin(studioId, date, slot) {
    try {
      localStorage.setItem(PRESELECT_KEY, JSON.stringify({
        collectionId: CONFIG.collectionId,
        studioId: studioId,
        date: date,
        slot: slot || null
      }));
      localStorage.setItem(RETURN_KEY, window.location.href);
    } catch (e) {}
    var loginLink = document.querySelector('a[href*="/account/login"]') || document.querySelector('.pa-login-gate a.pa-btn-primary');
    if (loginLink && loginLink.href) {
      window.location.href = loginLink.href;
    } else {
      window.location.href = '/account/login';
    }
  }

  function combinedSpacesLeft(dateOfferings) {
    var known = dateOfferings.filter(function (o) { return o.spacesLeft !== null; });
    if (!known.length) return null;
    return Math.min.apply(null, known.map(function (o) { return o.spacesLeft; }));
  }

  function renderCalendar(studioId) {
    currentStudioId = studioId;
    var container = q('cp-dates-list');
    container.innerHTML = '';
    calYear = null;
    calMonth = null;

    var today = new Date();
    today.setHours(0, 0, 0, 0);

    var offeringsByDate = {};
    allOfferings
      .filter(function (o) { return o.studioId === studioId; })
      .forEach(function (o) {
        var d = new Date(o.date + 'T00:00:00');
        var soldOut = (o.spacesLeft !== null && o.spacesLeft <= 0) || o.available === false;
        if (d < today || soldOut) return;
        if (!offeringsByDate[o.date]) offeringsByDate[o.date] = [];
        offeringsByDate[o.date].push(o);
      });

    Object.keys(offeringsByDate).forEach(function (key) {
      offeringsByDate[key].sort(function (a, b) {
        var aSlot = offeringTimeSlot(a), bSlot = offeringTimeSlot(b);
        if (aSlot === bSlot) return 0;
        return aSlot === 'AM' ? -1 : 1;
      });
    });

    var sortedDates = Object.keys(offeringsByDate).sort();

    if (!sortedDates.length) {
      container.innerHTML = '<p class="pa-empty">No upcoming dates are open for booking at this studio yet. Please check back soon.</p>';
      return;
    }

    var minDate = new Date(sortedDates[0] + 'T00:00:00');
    var maxDate = new Date(sortedDates[sortedDates.length - 1] + 'T00:00:00');
    var startAnchor = minDate > today ? minDate : today;
    calYear = startAnchor.getFullYear();
    calMonth = startAnchor.getMonth();

    var legend = document.createElement('div');
    legend.className = 'pa-cal-legend';
    legend.innerHTML =
      '<span><span class="pa-cal-dot pa-cal-dot-available"></span>Available</span>' +
      '<span><span class="pa-cal-dot pa-cal-dot-limited"></span>Few spots left</span>';
    container.appendChild(legend);

    var note = document.createElement('p');
    note.className = 'pa-selected-dates';
    note.style.marginTop = '-4px';
    note.textContent = 'Tap a date to continue \u2014 you\u2019ll be asked to log in, then brought right back here.';
    container.appendChild(note);

    var calWrap = document.createElement('div');
    calWrap.className = 'pa-cal-wrap';
    container.appendChild(calWrap);

    function monthKey(y, m) { return y * 12 + m; }
    var minMonthKey = monthKey(today.getFullYear(), today.getMonth());
    var maxMonthKey = monthKey(maxDate.getFullYear(), maxDate.getMonth());

    function draw() {
      calWrap.innerHTML = '';
      var year = calYear, month = calMonth;
      var mNames = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      var firstDay = new Date(year, month, 1).getDay();
      var daysInMonth = new Date(year, month + 1, 0).getDate();
      var curKey = monthKey(year, month);

      var header = document.createElement('div');
      header.className = 'pa-cal-header';

      var prevBtn = document.createElement('button');
      prevBtn.type = 'button';
      prevBtn.className = 'pa-cal-arrow';
      prevBtn.innerHTML = '\u2190';
      prevBtn.disabled = curKey <= minMonthKey;
      prevBtn.addEventListener('click', function () {
        calMonth--;
        if (calMonth < 0) { calMonth = 11; calYear--; }
        draw();
      });

      var nextBtn = document.createElement('button');
      nextBtn.type = 'button';
      nextBtn.className = 'pa-cal-arrow';
      nextBtn.innerHTML = '\u2192';
      nextBtn.disabled = curKey >= maxMonthKey;
      nextBtn.addEventListener('click', function () {
        calMonth++;
        if (calMonth > 11) { calMonth = 0; calYear++; }
        draw();
      });

      var label = document.createElement('span');
      label.textContent = mNames[month] + ' ' + year;

      header.appendChild(prevBtn);
      header.appendChild(label);
      header.appendChild(nextBtn);
      calWrap.appendChild(header);

      var grid = document.createElement('div');
      grid.className = 'pa-cal-grid';
      ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].forEach(function (d) {
        var dl = document.createElement('div');
        dl.className = 'pa-cal-day-label';
        dl.textContent = d;
        grid.appendChild(dl);
      });

      for (var e = 0; e < firstDay; e++) {
        var empty = document.createElement('div');
        empty.className = 'pa-cal-day pa-cal-empty';
        grid.appendChild(empty);
      }

      for (var d = 1; d <= daysInMonth; d++) {
        var dt = new Date(year, month, d);
        var key = dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(d).padStart(2, '0');
        var dateOfferings = offeringsByDate[key];
        var cell = document.createElement('div');

        if (dateOfferings && dateOfferings.length > 1) {
          cell.className = 'pa-cal-day pa-cal-day-split';
          var num2 = document.createElement('span');
          num2.className = 'pa-cal-day-num pa-cal-day-num-split';
          num2.textContent = String(d);
          cell.appendChild(num2);

          var halves = document.createElement('div');
          halves.className = 'pa-cal-halves';
          dateOfferings.forEach(function (o) {
            var slot = offeringTimeSlot(o);
            var half = document.createElement('div');
            var halfCls = 'pa-cal-half';
            if (o.spacesLeft !== null && o.spacesLeft <= 5) {
              halfCls += ' pa-cal-half-limited';
            } else {
              halfCls += ' pa-cal-half-available';
            }
            half.className = halfCls;
            half.textContent = slot;
            half.addEventListener('click', function (clickedKey, clickedSlot) {
              return function () { goToLogin(studioId, clickedKey, clickedSlot); };
            }(key, slot));
            halves.appendChild(half);
          });
          cell.appendChild(halves);
          grid.appendChild(cell);
          continue;
        }

        var spacesLeft = dateOfferings ? combinedSpacesLeft(dateOfferings) : null;
        var cls = 'pa-cal-day';
        if (!dateOfferings) {
          cls += ' pa-cal-unavailable';
        } else if (spacesLeft !== null && spacesLeft <= 5) {
          cls += ' pa-cal-limited';
        } else {
          cls += ' pa-cal-available';
        }
        cell.className = cls;

        var num = document.createElement('span');
        num.className = 'pa-cal-day-num';
        num.textContent = String(d);
        cell.appendChild(num);

        if (dateOfferings) {
          if (spacesLeft !== null && spacesLeft <= 5) {
            var badge = document.createElement('span');
            badge.className = 'pa-cal-spots-num';
            badge.textContent = spacesLeft;
            cell.appendChild(badge);
          }
          cell.addEventListener('click', function (clickedKey, clickedOfferings) {
            return function () { goToLogin(studioId, clickedKey, offeringTimeSlot(clickedOfferings[0])); };
          }(key, dateOfferings));
        }

        grid.appendChild(cell);
      }

      calWrap.appendChild(grid);
    }

    draw();
  }

  function cpInit() {
    if (!q('cp-widget')) return;
    if (q('cp-widget').dataset.cpReady === '1') return;
    q('cp-widget').dataset.cpReady = '1';

    fetchCollectionProducts()
      .then(function (products) {
        allOfferings = buildOfferings(products);
        var studioIds = [];
        allOfferings.forEach(function (o) {
          if (o.available && studioIds.indexOf(o.studioId) === -1) studioIds.push(o.studioId);
        });
        populateStudioSelect(studioIds);

        var pre = getPreselectStudio();
        if (pre && studioIds.indexOf(pre) !== -1) {
          q('cp-studio-select').value = pre;
          renderCalendar(pre);
        }
      })
      .catch(function (err) {
        console.error('Camp preview widget error:', err);
      });

    q('cp-studio-select').addEventListener('change', function (e) {
      if (e.target.value) renderCalendar(e.target.value);
      else q('cp-dates-list').innerHTML = '';
    });
  }

  cpInit();
  document.addEventListener('DOMContentLoaded', cpInit);
  window.addEventListener('load', cpInit);
})();